const ChangeReservationResults = ({ outcome }) => {
  if (!outcome || outcome.kind === "validation_error" || !outcome.items?.length) {
    return null;
  }

  const showSummary = outcome.totalCount > 1 || outcome.kind === "partial";

  return (
    <div className="change-interval-results">
      {showSummary ? (
        <div className="change-interval-results-summary">
          <span className="change-interval-results-summary-item change-interval-results-summary-item--total">
            کل: {outcome.totalCount}
          </span>
          <span className="change-interval-results-summary-item change-interval-results-summary-item--success">
            موفق: {outcome.successCount}
          </span>
          <span className="change-interval-results-summary-item change-interval-results-summary-item--failed">
            ناموفق: {outcome.failedCount}
          </span>
        </div>
      ) : (
        ""
      )}

      <div className="change-interval-results-table-wrap">
        <div className="change-interval-results-table">
          <div className="change-interval-results-table-head">
            <div>شناسه سفارش دهنده</div>
            <div>شماره سفارش</div>
            <div>نتیجه</div>
            <div>پیام</div>
          </div>
          {outcome.items.map((item, index) => (
            <div
              className={[
                "change-interval-results-table-row",
                item.success
                  ? "change-interval-results-table-row--success"
                  : "change-interval-results-table-row--failed",
              ].join(" ")}
              key={`${item.courierTrackNumber || "item"}-${index}`}
            >
              <div className="change-interval-mono">
                {item.courierTrackNumber || "-"}
              </div>
              <div className="change-interval-mono">
                {item.orderNumber || "-"}
              </div>
              <div>
                <span
                  className={[
                    "change-interval-status-chip",
                    item.success
                      ? "change-interval-status-chip--yes"
                      : "change-interval-status-chip--no",
                  ].join(" ")}
                >
                  {item.success ? "موفق" : "ناموفق"}
                </span>
              </div>
              <div className="change-interval-results-message">
                {item.message || item.errorMessage || item.errorCode || "—"}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChangeReservationResults;
